/**
 * Destination de retour après connexion, nettoyée de tout ce qui pourrait
 * envoyer le client ailleurs que sur le site.
 *
 * Le paramètre vient de l'URL : sans ce filtre, `?redirect=https://ailleurs`
 * ferait de la page de connexion un tremplin vers un site tiers — le client
 * saisirait ses identifiants chez nous puis atterrirait sur une copie. Seul un
 * chemin interne est accepté ; `//evil.com` est rejeté aussi, un navigateur le
 * lit comme une URL absolue.
 */
export const toSafeRedirect = (redirect: string | undefined): string => {
  if (!redirect?.startsWith('/') || redirect.startsWith('//')) {
    return '/'
  }

  return redirect
}
